import Vue from 'vue'
import Vuex from 'vuex'
import { nodes } from '@/store/modules/nodes'
import { batteries } from './modules/batteries'
import authentication from './modules/authentication'
import { app } from './modules/app'
import { zones } from './modules/zones'
import { groups } from './modules/groups'
import { gateways } from './modules/gateways'
import layouts from './modules/layouts'
import user from './modules/user'
import project from './modules/project'
import schedules from './modules/schedules'
import commands from './modules/commands'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        user,
        authentication,
        app,
        nodes,
        zones,
        batteries,
        gateways,
        layouts,
        project,
        schedules,
        commands,
        groups
    },
    actions: {
        resetStore({ commit }) {
            commit('authentication/RESET')
            commit('commands/RESET')
            commit('gateways/RESET')
            commit('layouts/RESET')
            commit('nodes/RESET')
            commit('schedules/RESET')
            commit('zones/RESET')
            commit('groups/RESET')
            commit('batteries/RESET')
        }
    }
})
